import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestLicenseTelemetryGet = {
  path: "/plugin-update/:slug/telemetry/:blogId",
  method: RouteHttpVerb.GET
};